export const ADD_RESERVACION = "ADD_RESERVACION";
export const RESET = "RESET";


export const addReservacion = reservacion => ({
    type: ADD_RESERVACION,
    reservacion
})

export const reset = () => ({
    type: RESET
})








